  import React, { useRef, useState, useEffect } from "react";
  import IMAGE1 from "../assets/images/Amenities img1 (1).png";
  import IMAGE2 from "../assets/images/Amenities img2 (1).png";
  import IMAGE3 from "../assets/images/Amenities img6.png";
  import IMAGE4 from "../assets/images/Amenities img8.png";
  import IMAGE5 from "../assets/images/Amenities img7.png";
  import IMAGE6 from "../assets/images/Amenities img10.png";
  import IMAGE7 from "../assets/images/Amenities img9.png";
  import IMAGE8 from "../assets/images/Amenities img3.png";
  import IMAGE9 from "../assets/images/Amenities img4.png";
  import IMAGE10 from "../assets/images/Amenities img5.png";
  import LEFTARROW from "../assets/images/leftarrow.png";
  import RIGHTARROW from "../assets/images/rightarrow.png";

  const Carousel = () => {
    const sliderRef = useRef(null);
    const [visibleSlides, setVisibleSlides] = useState(3);
    const [slideWidth, setSlideWidth] = useState(400);
    const [currentIndex, setCurrentIndex] = useState(visibleSlides); // Start at the first duplicate set
    const [isTransitioning, setIsTransitioning] = useState(false);

    const images = [
      IMAGE3,
      IMAGE4,
      IMAGE5,
      IMAGE6,
      IMAGE7,
      IMAGE8,
      IMAGE9,
      IMAGE10,
      IMAGE1,
      IMAGE2,
    ];

    const headings = [
      "Outdoor Games",
      "Club House",
      "Gymnasium",
      "Garden",
      "Multipurpose Hall",
      "Kids Play Area",
      "Swimming Pool",
      "Yoga Lawn",
      "Senior Citizen Area",
      "Multipurpose Hall",
    ];

    const duplicatedImages = [...images.slice(-visibleSlides), ...images, ...images.slice(0, visibleSlides)];
    const duplicatedHeadings = [...headings.slice(-visibleSlides), ...headings, ...headings.slice(0, visibleSlides)];

    const [currentHeading, setCurrentHeading] = useState(headings[0]);

    useEffect(() => {
      const updateScreenSize = () => {
        const screenWidth = window.innerWidth;
    
        if (screenWidth >= 1440) {
          setVisibleSlides(3);
          setSlideWidth(400);
        } else if (screenWidth >= 1024) {
          setVisibleSlides(3);
          setSlideWidth(300);
        }  else if (screenWidth >= 768) {
            setVisibleSlides(1);
            setSlideWidth(700);
          } else {
            setVisibleSlides(1);
            setSlideWidth(350); // Full width for medium and small screens
          }
      };
    
      updateScreenSize();
      window.addEventListener("resize", updateScreenSize);
      return () => window.removeEventListener("resize", updateScreenSize);
    }, []);
    

    const handleTransitionEnd = () => {
      setIsTransitioning(false);

      if (currentIndex === 0) {
        setCurrentIndex(images.length);
        sliderRef.current.style.transition = "none"; 
        sliderRef.current.style.transform = `translateX(-${
          images.length * (slideWidth + 24)
        }px)`;
      } else if (currentIndex === duplicatedImages.length - visibleSlides) {
        setCurrentIndex(visibleSlides);
        sliderRef.current.style.transition = "none";
        sliderRef.current.style.transform = `translateX(-${
          visibleSlides * (slideWidth + 24)
        }px)`;
      }
    };

    const moveSlides = (direction) => {
      if (isTransitioning) return;

      setIsTransitioning(true);

      let newIndex = currentIndex + direction;

      setCurrentIndex(newIndex);
      setCurrentHeading(
        duplicatedHeadings[newIndex + Math.floor(visibleSlides / 2)]
      );

      sliderRef.current.style.transition = "transform 0.5s ease-in-out"; // Re-enable transition
      sliderRef.current.style.transform = `translateX(-${
        newIndex * (slideWidth + 24)
      }px)`;
    };


    useEffect(() => {
      const slider = sliderRef.current;
      
      if (!slider) return; // Ensure the ref exists before adding event listener
    
      slider.addEventListener("transitionend", handleTransitionEnd);
    
      return () => {
        if (slider) {
          slider.removeEventListener("transitionend", handleTransitionEnd);
        }
      };
    }, [currentIndex]);

    return (
      <div className="flex flex-col items-center">
        <h1 className="font-bold lg:text-[40px] md:text-[28px] text-[22px] text-center">
          {currentHeading}
        </h1>
        <div className="relative w-full max-w-[1250px] overflow-hidden mt-6">
          <div
            ref={sliderRef}
            className="flex transition-transform duration-500 ease-in-out gap-6  "
            style={{
              transform: `translateX(-${currentIndex * (slideWidth + 24)}px)`,
            }}
          >
            {duplicatedImages.map((image, index) => (
              <div
                key={index}
                className={`rounded-lg flex-shrink-0 transition-transform duration-300 
                  ${
                    index === currentIndex + Math.floor(visibleSlides / 2)
                      ? "opacity-100 scale-100"
                      : "opacity-50 scale-90"
                  }`}
                style={{
                  width: `${slideWidth}px`,
                  height: "350px",
                }}
              >
                <img
                  src={image}
                  alt={`Slide ${index + 1}`}
                  className="w-full h-full rounded-lg"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Navigation Arrows */}
        <div className="flex justify-center items-center gap-6 mt-6">
          <img
            src={LEFTARROW}
            alt="left arrow"
            className="w-12 h-12 cursor-pointer"
            onClick={() => moveSlides(-1)}
          />
          <img
            src={RIGHTARROW}
            alt="right arrow"
            className="w-12 h-12 cursor-pointer"
            onClick={() => moveSlides(1)}
          />
        </div>
      </div>
    );
  };

  export default Carousel;


